var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMulticolor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 356 356",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.5.5h356v356H.5z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fillRule: "evenodd",
    xlinkHref: "#a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-.5 -.5)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#d8d8d8",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.048 177.048L43.112-45.485C83.112-70.247 129.874-82 177.492-82z",
    fill: "#ef1a18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.048 177.048L-49.62 51.333C-26.762 9.43 1.81-21.047 43.714-45.81z",
    fill: "#c60e7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.048 177.048L-82 179.225c0-47.619 9.524-85.987 32.381-127.892z",
    fill: "#662993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45.537 310.898C-70.299 268.994-82 225.62-82 178l259.048-.952z",
    fill: "#283194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.048 177.048L51.333 403.714c-41.904-22.857-72.38-51.428-97.143-93.333z",
    fill: "#1563b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.048 177.048l3.81 259.047c-47.62 0-87.62-9.524-129.525-32.38z",
    fill: "#00a3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.048 177.048L306.57 401.81c-41.903 22.857-80.95 34.285-128.57 34.285z",
    fill: "#10b146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.048 177.048L401.81 306.57c-22.858 41.905-53.334 70.477-95.239 95.239z",
    fill: "#89c832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.048 177.048h259.047c0 47.619-11.428 87.619-34.285 129.523z",
    fill: "#f3ee00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.048 177.048L401.81 47.524c22.857 41.905 34.285 81.905 34.285 129.524z",
    fill: "#fec900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.048 177.048L306.57-47.714c41.905 22.857 70.477 53.333 95.239 95.238z",
    fill: "#f99500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.048 177.048V-82c47.619 0 87.619 11.429 129.523 34.286z",
    fill: "#f46807"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulticolor);
export default __webpack_public_path__ + "static/media/multicolor.45085a87b6ac03509e969e99733331de.svg";
export { ForwardRef as ReactComponent };